import React from 'react';
import ReactDOM from 'react-dom';
import {App} from "./App"; // Import your root component

ReactDOM.render(<App />, document.getElementById('root'));
